/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Edit_TitleInputs */

const en_admin_payments_edit_title = /** @type {(inputs: Admin_Payments_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Order`)
};

/**
* | output |
* | --- |
* | "Edit Order" |
*
* @param {Admin_Payments_Edit_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_payments_edit_title = /** @type {((inputs?: Admin_Payments_Edit_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Edit_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_payments_edit_title(inputs)
});
export { admin_payments_edit_title as "admin.payments.edit_title" }